import { List } from 'immutable';

const isList = List.isList;

// mergeWith/mergeDeep with lists in immutablejs does not work as "expected"
// prev => { a: [10, 40], b1: false }
// next => { a: [10], b1: true }
//
// prev.mergeDeep(next)
// my_expected_result => { a: [10], b1: true }
// actual_result => { a: [10, 40], b1: true }
//
// why this happens:
// https://github.com/facebook/immutable-js/issues/781
//
// what this solution is doing:
// https://stackoverflow.com/questions/37192616/immutablejs-mergewith-objects-but-overwrite-new-lists
export default function mergeWithArray(prev, next) {
  if (isList(prev) || typeof prev !== 'object' || !prev.mergeWith) {
    return next;
  } else {
    return prev.mergeWith(mergeWithArray, next);
  }
}
